import { z } from 'zod'

const useZodErrorMap = () => {
  const customErrorMap: z.ZodErrorMap = (issue, ctx) => {
    if (issue.code === z.ZodIssueCode.invalid_type) {
      if (issue.expected === 'string') {
        return { message: t('zodI18n.errors.invalid_type_received_undefined') }
      } else if (issue.expected === 'number') {
        return { message: t('zodI18n.errors.invalid_type_received_undefined') }
      }
    }
    if (issue.code === z.ZodIssueCode.too_small) {
      if (issue.minimum) {
        return {
          message: t('zodI18n.errors.too_small.string.inclusive', {
            minimum: issue.minimum,
          }),
        }
      }
    }
    if (issue.code === z.ZodIssueCode.too_big) {
      if (issue.maximum) {
        return {
          message: t('zodI18n.errors.too_big.string.inclusive', {
            maximum: issue.maximum,
          }),
        }
      }
    }
    if (issue.code === z.ZodIssueCode.invalid_string) {
      if (issue.validation === 'email') {
        return { message: t('zodI18n.errors.invalid_string.email') }
      }
    }
    return { message: ctx.defaultError }
  }

  return customErrorMap
}

const customErrorMap = useZodErrorMap()
z.setErrorMap(customErrorMap)
